import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const AdmitCard = () => {
  return (
    <>
    <PageTitle pagetitle="DOWNLOAD ADMIT CARD" />
    <div className=''>
      
      
    </div>
    </>
  )
}

export default AdmitCard